import React from 'react'
import { pick } from 'ramda'
import DataKeys from 'k8s/DataKeys'
import useListAction from 'core/hooks/useListAction'
import { useSelector } from 'react-redux'
import {
  listMngmGroups,
  deleteMngmGroup,
} from 'account/components/ssoManagement/groups/new-actions'
import { groupsSelector } from 'account/components/ssoManagement/groups/selectors'
import { routes } from 'core/utils/routes'
import { createUsePrefParamsHook } from 'core/hooks/useParams'
import { listTablePrefs, TablePrefsParams } from 'app/constants'
import { ArrayElement } from 'core/actions/Action'
import { GridViewColumn } from 'core/elements/grid/Grid'
import DocumentMeta from 'core/components/DocumentMeta'
import ListContainer from 'core/containers/ListContainer'

type ModelDataKey = DataKeys.ManagementGroups
type SelectorModel = ArrayElement<ReturnType<typeof groupsSelector>>

const defaultParams = {}

const usePrefParams = createUsePrefParamsHook<TablePrefsParams>('UserGroups', listTablePrefs)
const searchTargets = ['name', 'description']

const columns: GridViewColumn<SelectorModel>[] = [
  { key: 'id', label: 'OpenStack ID', display: false },
  { key: 'name', label: 'Group Name' },
  { key: 'description', label: 'Description' },
]

export default function UserGroupsListPage() {
  const { params, getParamsUpdater } = usePrefParams(defaultParams)
  const { message, loading, reload } = useListAction(listMngmGroups)
  const data = useSelector(groupsSelector)

  return (
    <>
      <DocumentMeta title="Groups" />
      <ListContainer<ModelDataKey, SelectorModel>
        label="User Groups"
        searchTargets={searchTargets}
        uniqueIdentifier="id"
        loading={loading}
        loadingMessage={message}
        onRefresh={reload}
        columns={columns}
        data={data}
        getParamsUpdater={getParamsUpdater}
        addUrl={routes.userManagement.addGroup.path()}
        addText="New Group"
        editUrl={(_, id) => routes.userManagement.editGroup.path({ id })}
        deleteAction={deleteMngmGroup}
        showBreadcrumbs={false}
        {...pick(listTablePrefs, params)}
      />
    </>
  )
}
